<script>
    import SelectField from "../../../ui_elements/SelectField.svelte";
    export let value;
</script>

<SelectField bind:value id={value} label="Gewichtung" width="md:w-1/4">
    <option value="1">Normal</option>
    <option value="2">Wichtig</option>
    <option value="3">Knockout</option>
</SelectField>
